// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';

import { selectHasDomainCorporateProducts } from '@gandi/cart';
import { selectCurrentId } from '@gandi/redux-sharing';
import { useTranslator } from '@gandi/translate';
import { Base, Text, Svg } from '@gandi/ui';
import { ListRow, ListItem, ListCell } from '@gandi/ui/deprecated';

import {
  fetchOneCorpoPack,
  selectCorpoPack,
  type FetchOneCorpoPackAction,
  type ThunkAction,
} from 'src/Cart/modules/corporate';
import { useAppSelector } from 'src/hooks';

import { selectShopCurrent } from '../../modules/organization/selectors';

export type DispatchProps = {
  fetchOneCorpoPack: FetchOneCorpoPackAction<ThunkAction>,
  ...
};

const corporateBadgeStyle = {
  height: '1.5rem',
  marginRight: '1rem',
  width: 'auto',
};

export function CorporateAlert(): null | React.MixedElement {
  const { __, formatDate } = useTranslator();

  const sharingId = useAppSelector(selectCurrentId);
  const shopCurrent = useAppSelector(state => selectShopCurrent(state, false));
  const corpoPacks = useAppSelector(state => selectCorpoPack(state, sharingId));
  const hasCorporateProducts = useAppSelector(selectHasDomainCorporateProducts);

  const dispatch = useDispatch();

  const isCorporate = !!shopCurrent?.corporate;

  /// componentDidMount
  React.useEffect(() => {
    if (hasCorporateProducts && sharingId && isCorporate)
      dispatch(fetchOneCorpoPack(sharingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /// refetch corpo pack if needed
  React.useEffect(() => {
    if (hasCorporateProducts && sharingId && isCorporate)
      dispatch(fetchOneCorpoPack(sharingId));
  }, [hasCorporateProducts, sharingId, isCorporate, dispatch]);

  if (
    !hasCorporateProducts ||
    !isCorporate ||
    !Array.isArray(corpoPacks) ||
    !corpoPacks.length ||
    !sharingId
  )
    return null;

  const date = corpoPacks[0].date_end;

  return (
    <Base marginBottom="base">
      <ListRow>
        <ListItem backgroundColor="white">
          <ListCell>
            <Svg
              name="badgeCorporate"
              theme="success"
              title={__('Corporate')}
              style={corporateBadgeStyle}
            />
            <Text size="base" weight="semibold">
              {__(
                'This organization has an active Corporate Pack until %(date)s.',
                {
                  date: date ? formatDate(date, 'LL') : __('Unknown date'),
                },
              )}
            </Text>
          </ListCell>
        </ListItem>
      </ListRow>
    </Base>
  );
}
